import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Collapse,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import Aggrement from '../Aggrement/Aggrement';
import moment from 'moment';
import ItemRateMaster from '../ItemRate/ItemRateMaster';
import RemarkPage from '../../constants/RemarkPage';
import { useSelector } from 'react-redux';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';
import { Value } from 'sass';
import CustomerAddHelperMaster from '../../CustomModal/CustomerAddHelperMaster';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CityMaster from '../CityMaster/CityMaster';
import CustomModal from '../../constants/CustomModal';
import AddCityMaster from '../CityMaster/AddCityMaster';

import { number } from 'prop-types';
import Party from './Party';
import {
  initialPartyValue,
  initialPartyValueSuperAdmin,
} from '../../utils/RegisterMasterKeyword/PartyKeyword';
import { useMasterRegistry } from '../../hooks/useMasterRegistry';
import {
  allowOnlyNumberAndDot,
  allowOnlyNumberAndDotOnPaste,
} from '../../utils/helperFuncation';

const AddParty = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const today = moment();
  const maxDate = today.format('YYYY-MM-DD'); // Maximum date is today
  let initial = {
    name: '',
    email: '',
    mobile_number: null,
    address: '',
    pincode: null,
    hire_status: 'NA',
    agreement_start_date: maxDate,
    agreement_end_date: maxDate,
    bill_type: 'no_day',
    group: '',
    security_amount: null,
    tax_type: 'not_applicable',
    percentage: null,
    dr: '',
    gstin: '',
    ref_by: '',
    ref_commission: '',
    party_company_name: '',
    party_group_category_name: props?.partyGroup
      ? props?.partyGroup
      : 'DEBTORS',
    party_group_category_id: props?.partyGroupId ? props?.partyGroupId : '12',
    party_agr_code: '',

    gSTIN_No: '',
    pay_Term_Days: '',
    addhar_No: '',
    pAN_NO: '',
    ac_Opening_Date: maxDate,
    op_Bal: null,
    dr_Cr: '',

    DL_NO: '',

    martital_status: '',
    gender: ' ',
    dob: null,
    anniversary: null,
    loyalty: '',
    important: '',
    relation_type: '',
    swh_Name: '',
    case_master_case_no: '',

    party_branch_vendor_id: null,
    party_branch_master_id: null,
  };

  const [partyData, setPartyData] = useState(initial);
  const hireStatusRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorArrayMessage, setErrorArrayMessage] = useState('');
  const [accessButton, setAccessButton] = useState(false);

  let [editMode, setEditMode] = useState(false);
  const [addressTanxList, setAddressTanxList] = useState([
    //   {
    //   id: null,
    //   party_address_1: '',
    //   party_address_2: '',
    //   party_pincode: null,
    //   party_state: '',
    //   party_city: '',
    //   party_address_description: '',
    //   party_address_location: "",
    //   party_gst_type: "",
    //   party_gst_code: "",
    //   party_gst_address_no: "",
    // }
    // === primary address
    // {
    //   id: null,
    //   party_address_1: '',
    //   party_address_2: '',
    //   party_pincode: null,
    //   party_state: '',
    //   party_city: '',
    //   party_address_description: 'primary',
    //   party_address_location: "",
    //   party_gst_type: "",
    //   party_gst_code: "",
    //   party_gst_address_no: "",
    // }
  ]);

  const [contactTanxList, setContactTanxList] = useState([
    //   {
    //   id: null,
    //   party_contact_name: '',
    //   party_contact_mobile: null,
    //   party_contact_whatsapp_mobile: null,
    //   party_contact_email: '',
    //   party_contact_description: '',
    //   party_landline_no: null,
    //   party_contact_department: '',
    //   party_contact_designation: '',
    //   party_contact_website: '',
    //   party_contact_twitter_id: '',
    //   party_contact_fb_id: '',
    //   party_contact_youtube_id: "",
    // }
  ]);
  const [removeContactTransDeleteArray, setRemoveContactTransDeleteArray] =
    useState([]);
  const [removeAddressTransDeleteArray, setRemoveAddressTransDeleteArray] =
    useState([]);
  const [openAggrementFrom, setOpenAggrementFrom] = useState(false);

  const [partyCategoryTable, setPartyCategoryTable] = useState([]);
  const [helperMasterTaxPercentageTable, setHelperMasterTaxPercentageTable] =
    useState([]);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [systemRecords, setsystemRecords] = useState({});
  const [lastPartyId, setLastPartyId] = useState('');
  const [model, setModel] = useState('');

  const [remarkPageArrayList, setremarkPageArrayList] = useState([]);
  const [deleteRemarkPageArrayList, setDeleteRemarkPageArrayList] = useState(
    [],
  );
  let initialStaff = {
    staff_name: '',
    staff_email: '',
    staff_mobile: '',
    staff_dob: null,
    staff_aadhar: '',
    staff_profile: '',
    staff_role: '',
    staff_address: '',
    staff_joining_date: null,
    staff_department: '',
    staff_salary: 0,
    staff_status: 'active',
    staff_shift: '',
    staff_emergency_contact: '',
    staff_gender: '',
    staff_marital_status: '',
    staff_experience: '',
    staff_bank_details: '',
    branch_master_id: null,
  };
  const [staffDetail, setStaffDetail] = useState(initialStaff);
  const { user } = useSelector((state) => state.authState);

  const [partyCompanies, setPartyCompanies] = useState([
    {
      company_name: '',
      gst_no: '',
      state_name: '',
      state_id: null,
      // party_master_id: "",
    },
  ]);

  const [removePartyCompanies, setRemovePartyCompanies] = useState([]);
  const [registerMasterField, setRegisterMasterField] =
    useState(initialPartyValue);

  const onHandleBackParty = () => {
    navigate(-1);
  };

  useMasterRegistry({
    masterName: 'party',
    user,
    setState: setRegisterMasterField,
    superAdminDefaults: initialPartyValueSuperAdmin,
  });

  const onCancel = () => {
    if (props && typeof props.onCancel === 'function') {
      props.onCancel();
    }
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    if (name == 'tax_type') {
      setPartyData((prevData) => ({
        ...prevData,
        [name]: value,
        percentage: 0,
      }));
    } else if (name == 'name') {
      if (partyData.party_company_name == partyData.name) {
        setPartyData((prevData) => ({
          ...prevData,
          [name]: value,
          party_company_name: value,
          staff_name: value,
        }));

        if (!editMode) {
          const code = value
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase())
            .join('');
          setPartyData((prevData) => ({
            ...prevData,
            initial_party_code: code,
            party_agr_code: code,
            // + lastPartyId
          }));
        }
      } else {
        setPartyData((prevData) => ({
          ...prevData,
          [name]: value,
          staff_name: value,

          // party_agr_code: value
          //   .split(' ')
          //   .map(word => word.charAt(0).toUpperCase())
          //   .join('') + lastPartyId
        }));

        if (!editMode) {
          setPartyData((prevData) => ({
            ...prevData,
            party_agr_code: value
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase())
              .join(''),
            // + lastPartyId
          }));
        }
      }
    } else if (name == 'party_group_category_name') {
      const selectedIndex = e.target.options.selectedIndex;
      const selectedId =
        e.target.options[selectedIndex].getAttribute('data-id');
      const selectedName = e.target.value;

      let findArray = partyCategoryTable.find((data) => data.id == selectedId);

      setPartyData((prevData) => ({
        ...prevData,
        party_group_category_id: selectedId,
        party_group_category_name: selectedName,
        tds_master_id:
          findArray.tds_option == 'yes' ? findArray.tds_master_id : null,
        tds_rate: findArray.tds_option == 'yes' ? findArray.tds_rate : null,
        tds_option: findArray.tds_option == 'yes' ? findArray.tds_option : 'no',
      }));
    } else if (name == 'commission_type') {
      if (value == 'percentage' || value == 'compulsary') {
        setPartyData((prevData) => ({
          ...prevData,
          commission_amount: '',
        }));
      } else if (value == 'amount') {
        setPartyData((prevData) => ({
          ...prevData,
          [name]: value,
          commission_percentage: '',
        }));
      }
    }

    setPartyData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorMessage((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });

    // setErrorMessage((prevErrors) => ({
    //   ...prevErrors,
    //   [name]: '', // Clear the previous error when the user starts typing
    // }));
  };

  //vali
  const validateInputs = () => {
    const errors = {};

    const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

    if (!partyData.party_branch_vendor_id) {
      errors.party_branch_vendor_id = 'Vendor is required';
    }

    if (!partyData.party_branch_master_id) {
      errors.party_branch_master_id = 'Branch is required';
    }

    if (!partyData.hire_status) {
      errors.hire_status = 'Hire status is required';
    }

    if (!partyData.name) {
      errors.name = 'Party name is required';
    }

    if (!partyData.party_company_name) {
      errors.party_company_name = 'Party Company is required';
    }

    if (!partyData.party_group_category_name) {
      errors.party_group_category_name = 'Party Group is required';
    }

    if (partyData.PAN_NO && Object.keys(partyData.PAN_NO).length < 10) {
      errors.PAN_NO = 'Pan No. is invalid';
    }

    if (partyData.Op_Bal && !partyData.Dr_Cr) {
      errors.Dr_Cr = 'Debit/Credit is required ( Finanace Detail ) ';
    }

    if (partyData.security_amount && !partyData.dr) {
      errors.dr = 'Debit/Credit is required (Aggrement Detail)';
    }

    // if (!partyData.GSTIN_No) {
    //   errors.GSTIN_No = 'Gst No. is required';
    // }

    // if (!partyData.name) {
    //   errors.name = 'Party Name is required';
    // }

    // if (!partyData.email) {
    //   errors.email = 'Email is required';
    // } else if (!/\S+@\S+\.\S+/.test(partyData.email)) {
    //   errors.email = 'Invalid email address';
    // }

    // if (!partyData.mobile_number) {
    //   errors.mobile_number = 'Mobile Number is required';
    // } else if (!/^[0-9]{10}$/.test(partyData.mobile_number)) {
    //   errors.mobile_number = 'Invalid mobile number. Must be a 10-digit number';
    // }

    // if (!partyData.address) {
    //   errors.address = 'Party Address is required';
    // }

    // if (!partyData.pincode) {
    //   errors.pincode = 'Pincode is required';
    // } else if (!/^\d{6}$/.test(partyData.pincode)) {
    //   errors.pincode = 'Pincode must be a 6-digit number';
    // }
    return errors;
  };

  const validateAddresses = () => {
    const allErrors = [];

    addressTanxList.forEach((address, index) => {
      const errors = {};

      // if (address.party_address_description == "primary") {

      if (
        address.party_address_description == 'primary' &&
        (!address.party_address_1 ||
          !address.party_address_2 ||
          !address.party_pincode ||
          !address.party_state ||
          !address.party_city ||
          !address.party_address_location ||
          !address.party_gst_type ||
          !address.party_gst_code ||
          !address.party_gst_address_no ||
          !address.party_address_description)
      ) {
        if (!address.party_address_1) {
          errors.party_address_1 = `Address Line 1 is missing (Address ${index + 1})`;
        }

        if (!address.party_pincode) {
          errors.party_pincode = `Pincode is missing (Address ${index + 1})`;
        }
        if (!address.party_state) {
          errors.party_state = `State is missing (Address ${index + 1})`;
        }
        if (!address.party_city) {
          errors.party_city = `City is missing (Address ${index + 1})`;
        }
        if (!address.party_address_location) {
          errors.party_address_location = `Location/Landmarks is missing (Address ${index + 1})`;
        }
        if (!address.party_gst_type) {
          errors.party_gst_type = `GST Type is missing (Address ${index + 1})`;
        }
        if (!address.party_gst_code) {
          errors.party_gst_code = `State code is missing (Address ${index + 1})`;
        }
        // if (!address.party_gst_address_no) {
        //   errors.party_gst_address_no = `GST No. is missing (Address ${index + 1})`;
        // }
        if (!address.party_address_description) {
          errors.party_address_description = `Address Type is missing (Address ${index + 1})`;
        }

        console.log(errors);

        if (Object.keys(errors).length != 0) {
          allErrors.push(errors);
        }
      }
      // }
    });

    return allErrors;
    setErrorArrayMessage(allErrors);
  };

  async function uploadImagesFromArrayWithIndex(array) {
    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      console.log('djddj');
      if (
        obj.upload_document_path &&
        typeof obj.upload_document_path === 'object' &&
        obj.upload_document_path !== null &&
        'name' in obj.upload_document_path
      ) {
        try {
          const imageUrl = await uploadImage(obj.upload_document_path);
          obj.upload_document_path = imageUrl;
        } catch (error) {
          console.error(`Error uploading image for index ${i}:`, error);
        }
      }
    }
  }

  async function uploadImage(image) {
    const uploadData = new FormData();
    uploadData.append('signature', image);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        accept: 'application/json',
      },
    };

    try {
      const response = await apiService.post(
        '/api/CommonMaster/uploadfile',
        uploadData,
        config,
      );
      if (response.status === true) {
        return response.data;
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      throw new Error('Failed to upload image: ' + error.message);
    }
  }

  const [isSubmitting, setIsSubmitting] = useState(false);

  const addPartyData = async () => {
    try {
      // If already submitting, do nothing
      if (isSubmitting) {
        return;
      }

      setIsSubmitting(true);

      const errors = validateInputs();
      console.log(errors, 'erors ');
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        setShowErrorModal(true);
        setIsSubmitting(false);

        return;
      } else {
        setErrorMessage('');
      }

      let addressError = validateAddresses();
      if (addressError.length != 0) {
        setErrorArrayMessage(addressError);
        return;
      } else {
        setErrorArrayMessage('');
      }

      await uploadImagesFromArrayWithIndex(remarkPageArrayList);

      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      let params = {
        ...partyData,
        ...staffDetail,
        partyAddressTranskey: addressTanxList,
        partyConactTranskey: contactTanxList,
        PM_Remark_Upload_Detail_Key: remarkPageArrayList,
        PM_Remove_Remark_Upload_Detail_Key: deleteRemarkPageArrayList,
        partyCompanies_Key: partyCompanies,
        remove_PartyCompanies_Key: removePartyCompanies,
      };

      const response = await apiService.post(
        '/api/PartyMaster/create',
        params,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);

        // setPartyData(initial)
        // setStaffDetail(initialStaff)
        // setAddressTanxList([{
        //   id: null,
        //   party_address_1: '',
        //   party_address_2: '',
        //   party_pincode: null,
        //   party_state: '',
        //   party_city: '',
        //   party_address_description: '',
        //   party_gst_type: "",
        //   party_gst_code: "",
        //   party_gst_address_no: "",
        // }])

        // setContactTanxList([{
        //   party_contact_name: '',
        //   party_contact_mobile: null,
        //   party_contact_whatsapp_mobile: null,
        //   party_contact_email: '',
        //   party_contact_description: '',
        //   party_landline_no: null,
        //   party_contact_department: '',
        //   party_contact_designation: '',
        //   party_contact_website: '',
        //   party_contact_twitter_id: '',
        //   party_contact_fb_id: '',
        //   party_contact_youtube_id: "",
        // }])

        // if (hireStatusRef.current) {
        //   hireStatusRef.current.value = ""
        // }

        setErrorMessage('');
        setErrorArrayMessage('');
        if (props && typeof props.onInsert === 'function') {
          props?.onInsert();
        }

        getPartyData(response.partyMasterDetailByID.id);
        setEditMode(true);
      } else {
        console.log(response.response);
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error.meesage);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const onHandleAddressTranxChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...addressTanxList];

    if (name == 'party_state') {
      let findArray = stateTable.find((data) => data.state_Name == value);
      let branchData = branchMaster.find(
        (data) => data.id == partyData.party_branch_master_id,
      );
      if (Number(branchData.branch_state_code) == findArray?.state_Code) {
        list[index]['party_gst_type'] = 'SGST-CGST';
      } else {
        list[index]['party_gst_type'] = 'IGST';
      }

      list[index][name] = value;
      list[index]['party_state_id'] = findArray?.state_Id
        ? findArray?.state_Id
        : null;
      list[index]['party_gst_code'] = findArray?.state_Code
        ? findArray?.state_Code
        : '';
      list[index]['party_city'] = '';
      list[index]['party_city_id'] = null;

      setAddressTanxList(list);
    } else if (name == 'party_city') {
      if (value == '') {
        list[index]['party_city'] = '';
        list[index]['party_city_id'] = null;
      } else {
        let findArray = cityTable.find((data) => data.city_name == value);
        list[index]['party_city'] = value;
        list[index]['party_city_id'] = findArray.id;
      }
      setAddressTanxList(list);
    } else {
      list[index][name] = value;
      setAddressTanxList(list);
    }
  };

  const onHandleContactTranxChange = (e, index) => {
    const { name, value } = e.target;
    const updatedContacts = [...contactTanxList];
    updatedContacts[index] = {
      ...updatedContacts[index],
      [name]: value,
    };
    setContactTanxList(updatedContacts);
  };

  const refreshAddress = (e, index) => {
    const list = [...addressTanxList];
    list[index]['party_address_1'] = '';
    list[index]['party_address_2'] = '';
    list[index]['party_pincode'] = null;
    list[index]['party_state'] = '';
    list[index]['party_city'] = '';
    list[index]['party_address_description'] = '';
    list[index]['party_gst_type'] = '';
    list[index]['party_gst_code'] = '';
    list[index]['party_gst_address_no'] = '';
    list[index]['party_address_location'] = '';
    setAddressTanxList(list);
  };

  const handleAddRow = (name) => {
    if (name == 'address') {
      setAddressTanxList((prevState) => [
        ...prevState,
        {
          id: null,
          party_address_1: '',
          party_address_2: '',
          party_pincode: null,
          party_state: '',
          party_city: '',
          party_address_description: '',
          party_gst_type: '',
          party_gst_code: '',
          party_gst_address_no: '',
        },
      ]);
    } else if (name == 'contact') {
      setContactTanxList((prevState) => [
        ...prevState,
        {
          id: null,
          party_contact_name: '',
          party_contact_mobile: null,
          party_contact_whatsapp_mobile: null,
          party_contact_email: '',
          party_contact_description: '',
          party_landline_no: null,
          party_contact_department: '',
          party_contact_designation: '',
          party_contact_website: '',
          party_contact_twitter_id: '',
          party_contact_fb_id: '',
          party_contact_youtube_id: '',

          initial_party_code: '',
          currency: '',
          iec_no: '',
        },
      ]);
    }
  };

  const handleAddressRemoveRow = (index) => {
    const list = [...addressTanxList];
    const removedItem = list.splice(index, 1)[0];
    setAddressTanxList(list);
    setRemoveAddressTransDeleteArray([
      ...removeAddressTransDeleteArray,
      removedItem,
    ]);
  };

  const handleContactRemoveRow = (index) => {
    const list = [...contactTanxList];
    const removedItem = list.splice(index, 1)[0];
    setContactTanxList(list);
    setRemoveContactTransDeleteArray([
      ...removeContactTransDeleteArray,
      removedItem,
    ]);
  };

  const updatePartyData = async () => {
    try {
      // If already submitting, do nothing
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);

      const errors = validateInputs();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        setShowErrorModal(true);
        setIsSubmitting(false);

        return;
      } else {
        setErrorMessage('');
      }

      let addressError = validateAddresses();
      if (addressError.length != 0) {
        setErrorArrayMessage(addressError);
        return;
      } else {
        setErrorArrayMessage('');
      }

      await uploadImagesFromArrayWithIndex(remarkPageArrayList);

      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      let params = {
        ...partyData,
        ...staffDetail,
        partyAddressTranskey: addressTanxList,
        partyConactTranskey: contactTanxList,
        partyDeleteAddressTranskey: removeAddressTransDeleteArray,
        partyDeleteContactTranskey: removeContactTransDeleteArray,
        PM_Remark_Upload_Detail_Key: remarkPageArrayList,
        PM_Remove_Remark_Upload_Detail_Key: deleteRemarkPageArrayList,

        partyCompanies_Key: partyCompanies,
        remove_PartyCompanies_Key: removePartyCompanies,
      };

      const response = await apiService.put(
        `/api/PartyMaster/update?partyId=${partyData.id}`,
        params,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        setErrorArrayMessage('');
        setErrorMessage('');
        // navigate("/party")
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const getPartyData = async (partyId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/PartyMaster/getdetailbyid?id=${partyId}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setPartyData(response?.partyMasterDetailByID);
        setAddressTanxList(
          response?.partyMasterDetailByID?.partyAddressTransMaster,
        );
        setContactTanxList(
          response?.partyMasterDetailByID?.partyContactTransMaster,
        );
        setremarkPageArrayList(
          response.partyMasterDetailByID.remark_Upload_Detail,
        );
        setPartyCompanies(response.partyMasterDetailByID.partyCompanyTrans);
        setStaffDetail({
          staff_name: response?.partyMasterDetailByID?.staff_name || '',
          staff_email: response?.partyMasterDetailByID?.staff_email || '',
          staff_mobile: response?.partyMasterDetailByID?.staff_mobile || '',
          staff_dob: response?.partyMasterDetailByID?.staff_dob || null,
          staff_aadhar: response?.partyMasterDetailByID?.staff_aadhar || '',
          staff_profile: response?.partyMasterDetailByID?.staff_profile || '',
          staff_role: response?.partyMasterDetailByID?.staff_role || '',
          staff_address: response?.partyMasterDetailByID?.staff_address || '',
          staff_joining_date:
            response?.partyMasterDetailByID?.staff_joining_date || null,
          staff_department:
            response?.partyMasterDetailByID?.staff_department || '',
          staff_salary: response?.partyMasterDetailByID?.staff_salary || 0,
          staff_status:
            response?.partyMasterDetailByID?.staff_status || 'active',
          staff_shift: response?.partyMasterDetailByID?.staff_shift || '',
          staff_emergency_contact:
            response?.partyMasterDetailByID?.staff_emergency_contact || '',
          staff_gender: response?.partyMasterDetailByID?.staff_gender || '',
          staff_marital_status:
            response?.partyMasterDetailByID?.staff_marital_status || '',
          staff_experience:
            response?.partyMasterDetailByID?.staff_experience || '',
          staff_bank_details:
            response?.partyMasterDetailByID?.staff_bank_details || '',
        });

        setAccessButton(response?.canAccessData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getLastPartyById = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(`/api/PartyMaster/partyId`, config);
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setLastPartyId(response.lastId + 1);
        setErrorMessage('');
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    if (props && typeof props.onCancel === 'function') {
    } else {
      if (location.state) {
        getPartyData(location.state.partyId);
        setEditMode(true);
      } else {
        getLastPartyById();
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (user.user_profile == 'superadmin') {
      setAccessButton(true);
    }
  }, []);

  const goToAggrement = () => {
    setModel('aggrement');
    // navigate("/aggrement", { state: { partyId: partyData.id, partyName: partyData.name } })
  };

  const [credentialLoading, setCredentialLoading] = useState(false);

  const createUserCredentials = async () => {
    const error = {};

    if (!partyData.email) {
      error.email = 'Email is required';
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(partyData.email)) {
        error.email = 'Email is invalid';
      }
    }

    if (!partyData.mobile_number) {
      error.mobile_number = 'Mobile No. is required';
    } else {
      const mobilePattern = /^[0-9]{10}$/; // Assuming 10-digit mobile number
      if (!mobilePattern.test(partyData.mobile_number)) {
        error.mobile_number = 'Mobile No. is invalid';
      }
    }

    console.log(error, 'errro message ');

    if (Object.keys(error).length !== 0) {
      setErrorMessage(error);
      setShowErrorModal(true);
      setIsSubmitting(false);
      return;
    } else {
      setErrorMessage('');
    }

    console.log(isSubmitting, 'oissisisi');

    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      setCredentialLoading(true);
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.post(
        `/api/PartyMaster/credential`,
        partyData,
        config,
      );
      setCredentialLoading(false);

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        alert(response.message);
        getPartyData(partyData.id);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const goToItemRate = () => {
    setModel('item');
  };

  const backTOPartyMaster = () => {
    setModel('');
    getPartyData(partyData.id);
  };

  // useEffect(() => {
  //   const today = moment();
  //   const maxDate = today.format('YYYY-MM-DD'); // Maximum date is today
  //   setPartyData((prevData) => ({
  //     ...prevData,
  //     agreement_date: maxDate,
  //     Ac_Opening_Date: maxDate
  //   }));
  // }, []);

  const onHandleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      // const reader = new FileReader();
      // reader.onloadend = () => {
      //   setPreviewImage(reader.result);
      // };
      // reader.readAsDataURL(files[0]);
      // setStaffDetail(prevState => ({
      //   ...prevState,
      //   [name]: files[0]
      // }));
    } else {
      setStaffDetail((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  //  ============== party company Array  ======================
  // 🔹 Handle change in a particular company row
  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedCompanies = [...partyCompanies];

    // ✅ Always update the input field
    updatedCompanies[index][name] = value;
    // ✅ If state_id changes, auto-set state_name
    if (name === 'state_id') {
      const selectedState = stateTable.find(
        (st) => st.state_Id === parseInt(value),
      );

      console.log(selectedState, stateTable, 'selectedStateselectedState');

      if (selectedState) {
        updatedCompanies[index].state_id = selectedState.state_Id;
        updatedCompanies[index].state_name = selectedState.state_Name;
      } else {
        // reset if invalid ID entered
        updatedCompanies[index].state_name = '';
        updatedCompanies[index].state_id = null;
      }
    }

    setPartyCompanies(updatedCompanies);
  };

  // 🔹 Add new company row
  const addCompany = () => {
    setPartyCompanies([
      ...partyCompanies,
      {
        company_name: '',
        gst_no: '',
        state_name: '',
        state_id: '',
        party_master_id: '',
        created_by: 1,
      },
    ]);
  };

  // 🔹 Remove a company row
  const removeCompany = (index) => {
    const updatedCompanies = [...partyCompanies];
    const removedItem = updatedCompanies[index]; // 👈 capture removed data

    // 1️⃣ Remove the item from main array
    updatedCompanies.splice(index, 1);
    setPartyCompanies(updatedCompanies);

    // 2️⃣ Save removed data in a separate list
    setRemovePartyCompanies((prev) => [...prev, removedItem]);
  };

  // =====================    all helper master dropdown  fucntion and api  ==========================

  const [helperMasterAddressTable, setHelperMasterAddressTable] = useState([]);
  const [helperMasterContactTable, setHelperMasterContactTable] = useState([]);
  const [stateTable, setStateTable] = useState([]);
  const [cityTable, setCityTable] = useState([]);

  const [helperMasterDesignationTable, setHelperMasterDesignationTable] =
    useState([]);
  const [helperMasterDepartmentTable, setHelperMasterDepartmentTable] =
    useState([]);

  const [helperMasterAggrementTypeTable, setHelperMasterAggrementTypeTable] =
    useState([]);
  const [helperMasterBillTypeTable, setHelperMasterBillTypeTable] = useState(
    [],
  );
  const [helperMasterTaxTypeTable, setHelperMasterTaxTypeTable] = useState([]);

  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);
  const [helperMasterDocumentTypeTable, setHelperMasterDocumentTypeTable] =
    useState([]);
  const [helperMasterWorkBussinessTable, setHelperMasterWorkBussinessTable] =
    useState([]);

  // Generic function to fetch helper master data
  const getHelperMasterData = async (formName, setStateCallback) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/HelperMaster/allOption?fromName=${formName}`,
        config,
      );

      if (response.response?.data?.errors) {
        toast.success(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setStateCallback(response.helperMasterData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Something went wrong!!`);
    }
  };

  // useEffect with all the API calls
  useEffect(() => {
    getHelperMasterData(
      'remark_detail_document_party',
      setHelperMasterDocumentTypeTable,
    );
    getHelperMasterData('party_contact_detail', setHelperMasterContactTable);
    getHelperMasterData('party_address_detail', setHelperMasterAddressTable);
    getHelperMasterData('department', setHelperMasterDepartmentTable);
    getHelperMasterData('designation', setHelperMasterDesignationTable);
    getHelperMasterData('aggrement', setHelperMasterAggrementTypeTable);
    getHelperMasterData('item_tax-per', setHelperMasterTaxPercentageTable);
    getHelperMasterData('bill_type', setHelperMasterBillTypeTable);
    getHelperMasterData('tax_type', setHelperMasterTaxTypeTable);
    getHelperMasterData(
      'working_bussinesss_mode',
      setHelperMasterWorkBussinessTable,
    );

    getState();
    getCity();
    // getVendorList();
  }, []);

  const getState = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/HelperMaster/allState`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setStateTable(response.state_Master);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getVendorList = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.CompanyMasterMasterData)
        if (
          response.venderMasterData.length == 1 &&
          response.venderMasterData
        ) {
          setVenderMasterTable(response.venderMasterData);
          setPartyData((prevDetails) => ({
            ...prevDetails,
            party_branch_vendor_id: response.venderMasterData[0].id,
          }));
        } else {
          setVenderMasterTable(response.venderMasterData);
        }
        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  const getBranchList = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const filterName =
        user.user_profile == 'superadmin'
          ? partyData.party_branch_vendor_id
          : partyData.accessButton
            ? partyData.party_branch_vendor_id
            : null;
      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }

      const response = await apiService.get(
        `/api/BranchMaster/all?${queryString}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.BranchMasterMasterData)
        // setBranchMasterTable(response.branchMasterData)

        if (
          response.branchMasterData.length == 1 &&
          response.branchMasterData
        ) {
          setBranchMasterTable(response.branchMasterData);
          setPartyData((prevDetails) => ({
            ...prevDetails,
            party_branch_master_id: response.branchMasterData[0].id,
          }));
        }
        // else if (response.branchMasterData.length == 0) {
        //   setBranchMasterTable(response.branchMasterData)

        //   setPartyData((prevDetails) => ({
        //     ...prevDetails,
        //     party_branch_master_id: null
        //   }));

        //   setErrorMessage((prevDetails) => ({
        //     ...prevDetails,
        //     party_branch_master_id: 'Branch is required'
        //   }));

        //   setShowErrorModal(true)

        // }
        else {
          setBranchMasterTable(response.branchMasterData);
          // setPartyData((prevDetails) => ({
          //   ...prevDetails,
          //   party_branch_master_id: null
          // }));
        }

        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading((prev) => ({ ...prev, branch: false }));
    }
  };

  useEffect(() => {
    getVendorList();
    getBranchList();
  }, [partyData?.party_branch_vendor_id]);

  const getPartyCategoryData = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `/api/PartyCategoryMaster/allpartycategory?pageNo=1&limit=100000000`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setPartyCategoryTable(response.partyCategoryMasterData);

        let id = props?.partyGroupId ? props?.partyGroupId : 12;
        let finddata = response.partyCategoryMasterData.find(
          (data) => data.id == id,
        );
        // props?.partyGroupId ? props?.partyGroupId : "12"

        // console.log(finddata,"finddata.ratefinddata.rate")

        if (finddata) {
          setPartyData((prevState) => ({
            ...prevState, // spread previous state
            party_group_category_name: finddata.category_name,
            party_group_category_id: finddata.id,
            tds_master_id: finddata.tds_master_id,
            tds_option: finddata.tds_option,
            tds_rate: finddata.tds_rate,
          }));
        }

        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const [showHelperModal, setHelperModal] = useState(false);
  const [fromName, setFromName] = useState('');

  const openHelperModal = (flagname) => {
    setFromName(flagname);
    setHelperModal(true);
  };

  const closedHelperModal = () => {
    setHelperModal(false);
  };

  // Function to fetch helper master data
  const fetchHelperData = () => {
    if (fromName === 'remark_detail_document_party') {
      getHelperMasterData(
        'remark_detail_document_party',
        setHelperMasterDocumentTypeTable,
      );
    } else if (fromName === 'party_contact_detail') {
      getHelperMasterData('party_contact_detail', setHelperMasterContactTable);
    } else if (fromName === 'party_address_detail') {
      getHelperMasterData('party_address_detail', setHelperMasterAddressTable);
    } else if (fromName === 'department') {
      getHelperMasterData('department', setHelperMasterDepartmentTable);
    } else if (fromName === 'designation') {
      getHelperMasterData('designation', setHelperMasterDesignationTable);
    } else if (fromName === 'aggrement') {
      getHelperMasterData('aggrement', setHelperMasterAggrementTypeTable);
    } else if (fromName === 'item_tax-per') {
      getHelperMasterData('item_tax-per', setHelperMasterTaxPercentageTable);
    } else if (fromName === 'bill_type') {
      getHelperMasterData('bill_type', setHelperMasterBillTypeTable);
    } else if (fromName === 'tax_type') {
      getHelperMasterData('tax_type', setHelperMasterTaxTypeTable);
    } else {
      console.warn(`No helper master data found for: ${fromName}`);
    }
  };

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=party`;
    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  const onHandleDeleteParty = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `/api/PartyMaster/delete?partyId=${id}`,
          config,
        );
        if (response.response && response.response.data.errors) {
          toast.success(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          navigate('/party');
        } else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(`SomeThing went wrong!!`);
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  // get system records detail
  // const getSystemRecords = async () => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/System_Records/GetSystem_RecordsById`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setsystemRecords(response.system_RecordsDataById)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  useEffect(() => {
    getPartyCategoryData();
    // getSystemRecords()
  }, [!partyCategoryTable]);

  const toggleAccordion = (index) => {
    setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
  };

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );
    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.party_branch_vendor_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.party_branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }
  }, [branchMaster, venderMaster, pageloading]);

  // get city
  const getCity = async (state) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      // let findArray = stateTable.find((data) => data.state_Name == state)
      // ?stateId=${findArray.state_Id}

      const response = await apiService.get(
        `/api/CityMaster/allCitys?page=1&limit=100000`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCityTable(response.city_MasterDetailData);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // useEffect(() => {
  //   if (partyAddressTranskey?.branch_state) {
  //     getCity()
  //   }
  // }, [branchDetail?.branch_state])

  const [showSateCityModel, setShowSateCityModel] = useState(false);
  const [currentStateName, setCurrentStateName] = useState('');

  const openStateCityModal = (stateName) => {
    setShowSateCityModel(true);
    setCurrentStateName(stateName);
  };

  const closedStateCityModal = () => {
    setShowSateCityModel(false);
  };

  const onInsertSingleItemModel = () => {
    setShowSateCityModel(false);
    getCity();
  };

  if (Object.values(pageloading).some((status) => status == true)) {
    return <SpinnerLoader />;
  }

  return (
    <>
      {model == '' ? (
        <>
          <Row className='bg-white pd-20 card-box mb-5 toolbar-row sticky-top'>
            <Col className='d-flex flex-wrap justify-content-end align-items-center gap-2'>
              {props && typeof props.onCancel === 'function' ? (
                <>
                  <Button color='danger' className='mr-2' onClick={onCancel}>
                    <i className='fas fa-times text-white' />
                    Cancel
                  </Button>

                  <Button
                    className='mr-2'
                    color='success'
                    onClick={() => {
                      addPartyData();
                    }}
                    disabled={isSubmitting}
                  >
                    <i className='bi bi-save'></i>
                    <p
                      style={{
                        fontSize: 8,
                        padding: 0,
                        margin: 0,
                        fontWeight: 'bold',
                      }}
                    >
                      Save
                    </p>
                  </Button>
                </>
              ) : (
                <>
                  {accessButton && partyData.id && (
                    <>
                      <div className='dropdown'>
                        <Button
                          className='btn btn-primary btn-sm dropdown-toggle mr-2'
                          color='primary'
                          data-toggle='dropdown'
                          aria-expanded='true'
                        >
                          <i className='bi bi-three-dots-vertical'></i> More
                          Options
                        </Button>
                        <div
                          className='dropdown-menu dropdown-menu-right dropdown-menu-icon-list shadow-lg border'
                          x-placement='bottom-end'
                        >
                          {partyData.credential_yn == 'no' && (
                            <a
                              className='dropdown-item'
                              href='#'
                              onClick={createUserCredentials}
                            >
                              <i className='bi bi-person-plus-fill text-primary mr-2 border-bottom'></i>{' '}
                              {credentialLoading ? (
                                'Loading...'
                              ) : (
                                <> {'Create Credentials'}</>
                              )}
                            </a>
                          )}
                          <a
                            className='dropdown-item border-bottom'
                            href='#'
                            onClick={() => goToItemRate()}
                          >
                            <i className='bi bi-tag-fill text-success me-2 fw-bold'></i>{' '}
                            Item Rate
                          </a>
                          <a
                            className='dropdown-item border-bottom'
                            href='#'
                            onClick={goToAggrement}
                          >
                            <i className='bi bi-file-earmark-text-fill text-info me-2'></i>{' '}
                            {partyData.agreement_yn == 'yes'
                              ? 'Update Aggrement'
                              : 'New Aggrement'}
                          </a>
                          <a
                            className='dropdown-item border-bottom'
                            href='#'
                            onClick={() => goTODeleteModel(partyData.id)}
                          >
                            <i className='bi bi-trash-fill text-danger me-2'></i>{' '}
                            Delete Party
                          </a>
                        </div>
                      </div>
                    </>
                  )}

                  {editMode ? (
                    accessButton && (
                      <Button
                        className='mr-2 btn-sm'
                        color='success'
                        onClick={updatePartyData}
                        disabled={isSubmitting}
                      >
                        <i className='bi bi-check-circle mr-2'></i>Update
                      </Button>
                    )
                  ) : (
                    <Button
                      className='mr-2 btn-sm'
                      color='success'
                      onClick={addPartyData}
                      disabled={isSubmitting}
                    >
                      <i className='bi bi-save mr-2'></i>
                      Save
                    </Button>
                  )}

                  <Button
                    color='warning'
                    onClick={onHandleBackParty}
                    className='mr-0 btn-sm'
                  >
                    <i className='bi bi-arrow-left mr-0'></i> Back
                  </Button>
                </>
              )}
            </Col>
          </Row>

          <Card className='bg-white pd-10 card-box mb-30'>
            <CardTitle
              tag='h6'
              className='border-bottom p-3 mb-0 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-person-fill me-2'></i>
                <span>{editMode ? 'Update Party' : 'Create New Party'}</span>
              </div>

              {user.user_profile === 'superadmin' && (
                <div className='alert alert-danger mt-2 mt-md-0 ms-md-3 mb-0 small'>
                  This record is saved as <strong>USER CREATED</strong> by
                  default.
                  <br /> Super Admins can manually update it to{' '}
                  <strong>SYSTEM GENERATED</strong> when needed.
                </div>
              )}
            </CardTitle>

            <CardBody>
              <Form>
                <Row>
                  {/* // show only admin side  */}
                  {(venderMaster.length === 0 || venderMaster.length > 1) && (
                    <Col sm={12}>
                      <FormGroup>
                        <Label for='party_branch_vendor_id'>Vendor Name</Label>
                        <Input
                          className='custom-select'
                          type='select'
                          id='party_branch_vendor_id'
                          name='party_branch_vendor_id'
                          value={partyData.party_branch_vendor_id}
                          onChange={onChangeHandle}
                          disabled={!accessButton}
                        >
                          <option value=''>Select</option>
                          {venderMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.vender_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.party_branch_vendor_id && (
                          <FormText color='danger'>
                            {errorMessage.party_branch_vendor_id}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {(branchMaster.length === 0 || branchMaster.length > 1) && (
                    <Col sm={12}>
                      <FormGroup>
                        <Label for='party_branch_master_id'>Branch Name</Label>
                        <Input
                          className='custom-select'
                          type='select'
                          id='party_branch_master_id'
                          name='party_branch_master_id'
                          value={partyData.party_branch_master_id}
                          onChange={onChangeHandle}
                          disabled={!accessButton}
                        >
                          <option value=''>Select</option>
                          {branchMaster.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-id={option.id}
                            >
                              {option.branch_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.party_branch_master_id && (
                          <FormText color='danger'>
                            {errorMessage.party_branch_master_id}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col sm={6}>
                    <FormGroup>
                      <Label for='partyName'>Party Name</Label>
                      <Input
                        id='partyName'
                        name='name'
                        value={partyData.name}
                        onChange={onChangeHandle}
                      />
                      {errorMessage.name && (
                        <FormText color='danger'>{errorMessage.name}</FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label for='AgrCode'>System Pcode</Label>
                      <Input
                        id='AgrCode'
                        name='party_agr_code'
                        value={partyData.party_agr_code}
                        onChange={onChangeHandle}
                        disabled
                      />
                      {errorMessage.party_agr_code && (
                        <FormText color='danger'>
                          {errorMessage.party_agr_code}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label for='initial_party_code'>Initial PCode</Label>
                      <Input
                        id='initial_party_code'
                        name='initial_party_code'
                        value={partyData.initial_party_code}
                        onChange={onChangeHandle}
                      />
                      {errorMessage.initial_party_code && (
                        <FormText color='danger'>
                          {errorMessage.initial_party_code}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={12}>
                    <FormGroup>
                      <Label for='party_company_name'>Company Name</Label>
                      <Input
                        id='party_company_name'
                        name='party_company_name'
                        value={partyData.party_company_name}
                        onChange={onChangeHandle}
                      />
                      {errorMessage.party_company_name && (
                        <FormText color='danger'>
                          {errorMessage.party_company_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={6}>
                    <FormGroup>
                      <Label for='mobile_number'>
                        Mobile No. (primary){' '}
                        {partyData.credential_yn == 'yes' &&
                          '(User credentials are already set up.)'}
                      </Label>
                      <Input
                        type='tel'
                        maxLength={10}
                        id='mobile_number'
                        name='mobile_number'
                        value={partyData.mobile_number}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ''); // remove non-numeric
                          if (value.length <= 10) {
                            onChangeHandle({
                              target: { name: e.target.name, value },
                            });
                          }
                        }}
                      />
                      {errorMessage.mobile_number && (
                        <FormText color='danger'>
                          {errorMessage.mobile_number}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={6}>
                    <FormGroup>
                      <Label for='email'>Email (primary) </Label>
                      <Input
                        type='text'
                        id='email'
                        name='email'
                        value={partyData.email}
                        onChange={(e) => {
                          const value = e.target.value;
                          // if (value.length <= 10) {
                          onChangeHandle({
                            target: { name: e.target.name, value },
                          });
                          // }
                        }}
                      />
                      {errorMessage.email && (
                        <FormText color='danger'>{errorMessage.email}</FormText>
                      )}
                    </FormGroup>
                  </Col>
                  <Col xl={12}>
                    <FormGroup>
                      <Label for='party_group_category_name'>
                        Group/Category Name
                      </Label>
                      <Input
                        className='custom-select'
                        type='select'
                        id='party_group_category_name'
                        name='party_group_category_name'
                        value={partyData.party_group_category_name}
                        onChange={onChangeHandle}
                      >
                        <option value=''>Select</option>
                        {partyCategoryTable.map((option) => (
                          <option
                            key={option.id}
                            value={option.category_name}
                            data-id={option.id}
                          >
                            {option.category_name}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.party_group_category_name && (
                        <FormText color='danger'>
                          {errorMessage.party_group_category_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  {/* <Col>
                        <FormGroup>
                          <Label for="partyEmail">Email</Label>
                          <Input  
                            id="partyEmail"
                            name="email"
                            value={partyData.email}
                            onChange={onChangeHandle}
                            type="email"
                          />
                          {errorMessage.email && (
                            <FormText color="danger">{errorMessage.email}</FormText>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for="partyMobile">Mobile No.</Label>
                          <Input  
                            id="partyMobile"
                            name="mobile_number"
                            value={partyData.mobile_number}
                            onChange={onChangeHandle}
                            type="tel"
                          />
                          {errorMessage.mobile_number && (
                            <FormText color="danger">{errorMessage.mobile_number}</FormText>
                          )}
                        </FormGroup>
                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label for="partyAddress">Address</Label>
                          <Input  
                            id="partyAddress"
                            name="address"
                            value={partyData.address}
                            onChange={onChangeHandle}
                            type="text"
                          />
                          {errorMessage.address && (
                            <FormText color="danger">{errorMessage.address}</FormText>
                          )}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for="partyPincode">Pincode</Label>
                          <Input  
                            id="partyPincode"
                            name="pincode"
                            value={partyData.pincode}
                            onChange={onChangeHandle}
                            type="text"
                          />
                          {errorMessage.pincode && (
                            <FormText color="danger">{errorMessage.pincode}</FormText>
                          )}
                        </FormGroup>
                      </Col> */}
                </Row>
              </Form>
            </CardBody>

            {/* Multiple Company Detail */}
            {registerMasterField?.pty_acc_mul_compy_yn == 'yes' && (
              <div>
                {/* <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-bell mr-2"></i>
                      Finanace Detail
                    </div>
                  </CardTitle> */}

                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(12)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: '#3cbf41ff' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Multiple Company Detail
                  </div>
                  {openAccordion === 12 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 12
                  }
                >
                  <CardBody>
                    <Form>
                      {partyCompanies.map((item, index) => (
                        <div
                          key={index}
                          className='p-3 mb-3 border rounded position-relative'
                        >
                          <Row>
                            <Col sm={5}>
                              <FormGroup>
                                <Label>Company Name</Label>
                                <Input
                                  type='text'
                                  name='company_name'
                                  value={item.company_name}
                                  onChange={(e) => handleInputChange(index, e)}
                                  placeholder='Enter company name'
                                  required
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={3}>
                              <FormGroup>
                                <Label>GST No</Label>
                                <Input
                                  type='text'
                                  name='gst_no'
                                  value={item.gst_no}
                                  onChange={(e) => handleInputChange(index, e)}
                                  placeholder='Enter GST No'
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={3}>
                              <FormGroup>
                                <Label for='state_id'>State Name</Label>
                                <Input
                                  type='select'
                                  className='custom-select'
                                  name='state_id'
                                  id='state_id'
                                  value={item.state_id}
                                  onChange={(e) => handleInputChange(index, e)}
                                >
                                  <option value=''>Select</option>
                                  {stateTable.map((option) => (
                                    <option
                                      key={option.state_Id}
                                      value={option.state_Id}
                                    >
                                      {option.state_Name}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>

                            {/* Remove Button */}
                            <Col sm={1}>
                              {partyCompanies.length > 1 && (
                                <FormGroup>
                                  <Label for='state_id'>Action</Label>
                                  <Button
                                    color='danger'
                                    size='sm'
                                    className='my-1'
                                    // style={{ marginTop: 35 }}
                                    onClick={() => removeCompany(index)}
                                  >
                                    <i className='bi bi-trash'></i>
                                  </Button>
                                </FormGroup>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}

                      <div className='d-flex justify-content-between'>
                        <Button
                          color='secondary'
                          type='button'
                          onClick={addCompany}
                        >
                          + Add Another Company
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* Finanace and Document Detail */}
            {registerMasterField?.pty_acc_fin_doc_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(1)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: '#800080' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Finanace and Document Detail
                  </div>
                  {openAccordion === 1 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 1
                  }
                >
                  <CardBody>
                    <Form>
                      <Row>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Op_Bal'>Opening Bal</Label>
                            <Input
                              id='Op_Bal'
                              name='Op_Bal'
                              value={partyData.Op_Bal || ''}
                              onChange={onChangeHandle}
                              onKeyPress={allowOnlyNumberAndDot}
                              onPaste={allowOnlyNumberAndDotOnPaste}
                              type='text'
                            />
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Op_Bal_1'>Open Bal I</Label>
                            <Input
                              id='Op_Bal_1'
                              name='Op_Bal_1'
                              value={partyData.Op_Bal_1 || ''}
                              onChange={onChangeHandle}
                              onKeyPress={allowOnlyNumberAndDot}
                              onPaste={allowOnlyNumberAndDotOnPaste}
                              type='text'
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Op_Bal_2'>Open Bal II</Label>
                            <Input
                              id='Op_Bal_2'
                              name='Op_Bal_2'
                              value={partyData.Op_Bal_2 || ''}
                              onChange={onChangeHandle}
                              onKeyPress={allowOnlyNumberAndDot}
                              onPaste={allowOnlyNumberAndDotOnPaste}
                              type='text'
                            />
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Dr_Cr'>Debit/Credit</Label>
                            <Input
                              id='Dr_Cr'
                              name='Dr_Cr'
                              value={partyData.Dr_Cr || partyData.dr_Cr}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='debit'>Debit</option>
                              <option value='credit'>Credit</option>
                            </Input>
                            {errorMessage.Dr_Cr && (
                              <FormText color='danger'>
                                {errorMessage.Dr_Cr}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Pay_Term_Days'>
                              Payment Due After Days
                            </Label>
                            <Input
                              id='Pay_Term_Days'
                              name='Pay_Term_Days'
                              value={
                                partyData.Pay_Term_Days ||
                                partyData.pay_Term_Days
                              }
                              onChange={onChangeHandle}
                              type='text'
                            />
                            {errorMessage.Pay_Term_Days && (
                              <FormText color='danger'>
                                {errorMessage.Pay_Term_Days}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='ac_Opening_Date'>AC Opening Date</Label>
                            <Input
                              id='ac_Opening_Date'
                              name='ac_Opening_Date'
                              value={partyData?.ac_Opening_Date?.split('T')[0]}
                              onChange={onChangeHandle}
                              type='date'
                            />
                            {/* {errorMessage.agreement_date && (
                                <FormText color="danger">{errorMessage.agreement_date}</FormText>
                              )} */}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='GSTIN_No'>GSTIN (Primary)</Label>
                            <Input
                              id='GSTIN_No'
                              name='GSTIN_No'
                              value={partyData.GSTIN_No || partyData.gstiN_No}
                              onChange={onChangeHandle}
                              type='text'
                            />
                            {errorMessage.GSTIN_No && (
                              <FormText color='danger'>
                                {errorMessage.GSTIN_No}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='Addhar_No'>Addhar No.</Label>
                            <Input
                              id='Addhar_No'
                              name='Addhar_No'
                              value={partyData.Addhar_No || partyData.addhar_No}
                              onChange={onChangeHandle}
                              type='text'
                            />

                            {errorMessage.tax_type && (
                              <FormText color='danger'>
                                {errorMessage.tax_type}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='PAN_NO'>Pan No.</Label>
                            <Input
                              id='PAN_NO'
                              name='PAN_NO'
                              value={partyData?.PAN_NO || partyData?.paN_NO}
                              onChange={onChangeHandle}
                              type='text'
                            />

                            {errorMessage.PAN_NO && (
                              <FormText color='danger'>
                                {errorMessage.PAN_NO}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='DL_NO'>DL No.</Label>
                            <Input
                              id='DL_NO'
                              name='DL_NO'
                              value={partyData?.DL_NO || partyData?.dL_NO}
                              onChange={onChangeHandle}
                              type='text'
                            />

                            {errorMessage.DL_NO && (
                              <FormText color='danger'>
                                {errorMessage.DL_NO}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='commission_type'>Commission Type</Label>
                            <Input
                              id='commission_type'
                              name='commission_type'
                              value={partyData?.commission_type}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='percentage'>Percentage</option>
                              <option value='amount'>Amount</option>
                              <option value='both'>Both</option>
                              <option value='compulsary'>Compulsary</option>
                            </Input>
                          </FormGroup>
                        </Col>

                        {(partyData?.commission_type == 'percentage' ||
                          partyData?.commission_type == 'compulsary') && (
                          <Col xl={3}>
                            <FormGroup>
                              <Label for='commission_percentage'>
                                Commission Percentage
                              </Label>
                              <Input
                                id='commission_percentage'
                                name='commission_percentage'
                                value={partyData?.commission_percentage}
                                onChange={onChangeHandle}
                                type='text'
                              />
                            </FormGroup>
                          </Col>
                        )}

                        {partyData?.commission_type == 'amount' && (
                          <Col xl={3}>
                            <FormGroup>
                              <Label for='commission_amount'>
                                Commission Amount
                              </Label>
                              <Input
                                id='commission_amount'
                                name='commission_amount'
                                value={partyData?.commission_amount}
                                onChange={onChangeHandle}
                                type='text'
                              />
                            </FormGroup>
                          </Col>
                        )}

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='commission_on'>Commission ON</Label>
                            <Input
                              id='commission_on'
                              name='commission_on'
                              value={partyData?.commission_on}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='direct'>Direct</option>
                              <option value='indirect'>InDirect</option>
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='comm_expt_Buss'>
                              Expected Business
                            </Label>
                            <Input
                              id='comm_expt_Buss'
                              name='comm_expt_Buss'
                              value={partyData?.comm_expt_Buss}
                              onChange={onChangeHandle}
                              type='text'
                            />
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='comm_turner'>Turner/Duration</Label>
                            <Input
                              id='comm_turner'
                              name='comm_turner'
                              value={partyData?.comm_turner}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='per_year'>Per Year</option>
                              <option value='per_month'>Per Month</option>
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='currency'>Currency</Label>
                            <Input
                              id='currency'
                              name='currency'
                              value={partyData?.currency}
                              onChange={onChangeHandle}
                              type='text'
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='iec_no'>Iec No</Label>
                            <Input
                              id='iec_no'
                              name='iec_no'
                              value={partyData?.iec_no}
                              onChange={onChangeHandle}
                              type='text'
                            />
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='tds_option'>Tds Option</Label>
                            <Input
                              id='tds_option'
                              name='tds_option'
                              value={partyData?.tds_option}
                              // onChange={onChangeHandle}
                              type='text'
                              disabled
                              placeholder='TDS Option'
                            />
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='tds_rate'>Tds Rate</Label>
                            <Input
                              id='tds_rate'
                              name='tds_rate'
                              value={partyData?.tds_rate}
                              // onChange={onChangeHandle}
                              type='number'
                              disabled
                              placeholder='TDS Rate'
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={3}>
                          <FormGroup>
                            <Label for='sale_limit'>Sale Limit</Label>
                            <Input
                              id='sale_limit'
                              name='sale_limit'
                              type='number'
                              step='0.01'
                              value={partyData?.sale_limit}
                              placeholder='0.00'
                              onChange={onChangeHandle}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={3}>
                          <FormGroup>
                            <Label for='udhari'>Udhari (Borrowing)</Label>
                            <Input
                              id='udhari'
                              name='udhari'
                              type='number'
                              step='0.01'
                              placeholder='0.00'
                              value={partyData?.udhari}
                              onChange={onChangeHandle}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={3}>
                          <FormGroup>
                            <Label for='bayaz'>Bayaz (Interest)</Label>
                            <Input
                              id='bayaz'
                              name='bayaz'
                              type='number'
                              step='0.01'
                              placeholder='0.00'
                              value={partyData?.bayaz}
                              onChange={onChangeHandle}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* Staff Detail */}
            {registerMasterField?.pty_acc_stf_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(7)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: '#800080' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Staff Detail
                  </div>
                  {openAccordion === 6 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 7
                  }
                >
                  <CardBody>
                    <Form>
                      <Row>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_name'>Staff Name</Label>
                            <Input
                              type='text'
                              name='staff_name'
                              id='staff_name'
                              value={staffDetail.staff_name}
                              onChange={onHandleInputChange}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_email'>Email</Label>
                            <Input
                              type='email'
                              name='staff_email'
                              id='staff_email'
                              value={staffDetail.staff_email}
                              onChange={onHandleInputChange}
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_mobile'>Mobile Number</Label>
                            <Input
                              type='text'
                              name='staff_mobile'
                              id='staff_mobile'
                              value={staffDetail.staff_mobile}
                              onChange={onHandleInputChange}
                              required
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col xl={3}>
                              <FormGroup>
                                <Label for="staff_dob">Date of Birth</Label>
                                <Input  
                                  type="date"
                                  name="staff_dob"
                                  id="staff_dob"
                                  value={staffDetail.staff_dob?.split('T')[0]}
                                  onChange={onHandleInputChange}
                                  required
                                />
                              </FormGroup>
                            </Col> */}
                        {/* <Col xl={3}>

                              <FormGroup>
                                <Label for="staff_aadhar">Aadhar Number</Label>
                                <Input  
                                  type="text"
                                  name="staff_aadhar"
                                  id="staff_aadhar"
                                  value={staffDetail.staff_aadhar}
                                  onChange={onHandleInputChange}
                                />
                              </FormGroup>
                            </Col> */}
                        {/* <Col xl={3}>
     
                                         <FormGroup>
                                             <Label for="staff_profile">Profile Picture URL</Label>
                                             <Input  
                                                 type="text"
                                                 name="staff_profile"
                                                 id="staff_profile"
                                                 value={staffDetail.staff_profile}
                                                 onChange={onHandleInputChange}
                                             />
                                         </FormGroup>
                                     </Col> */}
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_role'>Role</Label>
                            <Input
                              type='select'
                              className='custom-select'
                              name='staff_role'
                              id='staff_role'
                              value={staffDetail.staff_role}
                              onChange={onHandleInputChange}
                              required
                            >
                              <option value=''>Select Role</option>
                              <option value='Manager'>Manager</option>
                              <option value='Receptionist'>Receptionist</option>
                              <option value='Chef'>Chef</option>
                              <option value='Housekeeping'>Housekeeping</option>
                              <option value='Bellboy'>Bellboy</option>
                              <option value='Waiter'>Waiter</option>
                              <option value='Maintenance'>Maintenance</option>
                              <option value='Security'>Security</option>
                              <option value='Concierge'>Concierge</option>
                              <option value='Valet'>Valet</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_address'>Address</Label>
                            <Input
                              type='text'
                              name='staff_address'
                              id='staff_address'
                              value={staffDetail.staff_address}
                              onChange={onHandleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_joining_date'>Joining Date</Label>
                            <Input
                              type='date'
                              name='staff_joining_date'
                              id='staff_joining_date'
                              value={
                                staffDetail.staff_joining_date?.split('T')[0]
                              }
                              onChange={onHandleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_department'>
                              Department
                              <i
                                className='fa fa-plus-circle'
                                onClick={() => {
                                  openHelperModal('department');
                                }}
                                style={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: 'blue',
                                  fontSize: 20,
                                }}
                              ></i>
                            </Label>
                            <Input
                              type='select'
                              className='custom-select'
                              name='staff_department'
                              id='staff_department'
                              value={staffDetail.staff_department}
                              onChange={onHandleInputChange}
                            >
                              {/* <option value="">Select Department</option> */}
                              <option value=''>Select</option>
                              {helperMasterDepartmentTable.map((option) => (
                                <option
                                  key={option.id}
                                  value={option.field_data}
                                >
                                  {option.field_name}
                                </option>
                              ))}
                              {/* <option value="Front Desk">Front Desk</option>
                                <option value="Housekeeping">Housekeeping</option>
                                <option value="Kitchen">Kitchen</option>
                                <option value="Food and Beverage">Food and Beverage</option>
                                <option value="Sales and Marketing">Sales and Marketing</option>
                                <option value="Accounting">Accounting</option>
                                <option value="Maintenance">Maintenance</option>
                                <option value="Security">Security</option>
                                <option value="Human Resources">Human Resources</option>
                                <option value="Guest Relations">Guest Relations</option>
                                <option value="IT">IT</option> */}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_salary'>Salary</Label>
                            <Input
                              type='number'
                              name='staff_salary'
                              id='staff_salary'
                              value={staffDetail.staff_salary}
                              onChange={onHandleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_status'>Status</Label>
                            <Input
                              type='select'
                              className='custom-select'
                              name='staff_status'
                              id='staff_status'
                              value={staffDetail.staff_status}
                              onChange={onHandleInputChange}
                            >
                              <option value='active'>Active</option>
                              <option value='inactive'>Inactive</option>
                              <option value='on_leave'>On Leave</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_shift'>Shift</Label>
                            <Input
                              type='select'
                              className='custom-select'
                              name='staff_shift'
                              id='staff_shift'
                              value={staffDetail.staff_shift}
                              onChange={onHandleInputChange}
                            >
                              <option value='Morning'>Morning</option>
                              <option value='Evening'>Evening</option>
                              <option value='Night'>Night</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_emergency_contact'>
                              Emergency Contact
                            </Label>
                            <Input
                              type='text'
                              name='staff_emergency_contact'
                              id='staff_emergency_contact'
                              value={staffDetail.staff_emergency_contact}
                              onChange={onHandleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col xl={3}>

          <FormGroup>
            <Label for="staff_gender">Gender</Label>
            <Input  
              type="select"  className="custom-select"
              name="staff_gender"
              id="staff_gender"
              value={staffDetail.staff_gender}
              onChange={onHandleInputChange}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Input>
          </FormGroup>
        </Col> */}
                        {/* <Col xl={3}>

          <FormGroup>
            <Label for="staff_marital_status">Marital Status</Label>
            <Input  
              type="select"  className="custom-select"
              name="staff_marital_status"
              id="staff_marital_status"
              value={staffDetail.staff_marital_status}
              onChange={onHandleInputChange}
            >
              <option value="">Select Marital Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
            </Input>
          </FormGroup>
        </Col> */}
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='staff_experience'>Experience</Label>
                            <Input
                              type='text'
                              name='staff_experience'
                              id='staff_experience'
                              value={staffDetail.staff_experience}
                              onChange={onHandleInputChange}
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col xl={3}>

          <FormGroup>
            <Label for="staff_bank_details">Bank Details</Label>
            <Input  
              type="text"
              name="staff_bank_details"
              id="staff_bank_details"
              value={staffDetail.staff_bank_details}
              onChange={onHandleInputChange}
            />
          </FormGroup>
        </Col> */}

                        {/* <Col xl={3}>
          <FormGroup>
            <Label for="branch_master_id">branch Name</Label>
            <Input  
              type="select"  className="custom-select"
              id="branch_master_id"
              name="branch_master_id"
              value={staffDetail.branch_master_id}
              onChange={onHandleInputChange}
            >
              <option value="">Select</option>
              {
                branchMasterTable.map((data) => (
                  <option value={data.id}>{data.branch_name}</option>
                ))
              }
            </Input>
          </FormGroup>
        </Col> */}
                      </Row>
                    </Form>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* Extra Detail */}
            {registerMasterField?.pty_acc_ext_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(6)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: '#800080' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Extra Detail
                  </div>
                  {openAccordion === 6 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 6
                  }
                >
                  <CardBody>
                    <Form>
                      <Row>
                        <Col sm={3}>
                          <FormGroup>
                            <Label for='martital_status'>Marital status</Label>
                            <Input
                              id='martital_status'
                              name='martital_status'
                              value={
                                partyData.martital_status ||
                                partyData.martital_status
                              }
                              onChange={onChangeHandle}
                              type='text'
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label for='gender'>Gender</Label>
                            <Input
                              id='gender'
                              name='gender'
                              value={partyData.gender || partyData.gender}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='male'>Male</option>
                              <option value='female'>Female</option>
                            </Input>
                            {errorMessage.gender && (
                              <FormText color='danger'>
                                {errorMessage.gender}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label for='dob'>Date of Birth</Label>
                            <Input
                              id='dob'
                              name='dob'
                              value={partyData?.dob?.split('T')[0]}
                              onChange={onChangeHandle}
                              type='date'
                            />
                            {errorMessage.dob && (
                              <FormText color='danger'>
                                {errorMessage.dob}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label for='anniversary'>Anniversary</Label>
                            <Input
                              id='anniversary'
                              name='anniversary'
                              value={partyData.anniversary?.split('T')[0]}
                              onChange={onChangeHandle}
                              type='date'
                            />
                            {/* {errorMessage.agreement_date && (
                                <FormText color="danger">{errorMessage.agreement_date}</FormText>
                              )} */}
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={3}>
                          <FormGroup>
                            <Label for='loyalty'>Loyalty</Label>
                            <Input
                              id='loyalty'
                              name='loyalty'
                              value={partyData.loyalty || partyData.loyalty}
                              onChange={onChangeHandle}
                              type='text'
                            />
                            {errorMessage.loyalty && (
                              <FormText color='danger'>
                                {errorMessage.loyalty}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='important'>Important.</Label>
                            <Input
                              id='important'
                              name='important'
                              value={partyData.important || partyData.important}
                              onChange={onChangeHandle}
                              type='text'
                            />

                            {errorMessage.important && (
                              <FormText color='danger'>
                                {errorMessage.important}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='relation_type'>Select S/H/W </Label>
                            <Input
                              id='relation_type'
                              name='relation_type'
                              value={partyData.relation_type}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='s'>S</option>
                              <option value='w'>W</option>
                              <option value='h'>H</option>
                            </Input>
                            {errorMessage.relation_type && (
                              <FormText color='danger'>
                                {errorMessage.relation_type}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='swh_Name'>S/W/H Name.</Label>
                            <Input
                              id='swh_Name'
                              name='swh_Name'
                              value={partyData.swh_Name}
                              onChange={onChangeHandle}
                              type='text'
                            />

                            {errorMessage.s_w_h_name && (
                              <FormText color='danger'>
                                {errorMessage.s_w_h_name}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col xl={3}>
                          <FormGroup>
                            <Label for='case_master_case_no'>Case No</Label>
                            <Input
                              id='case_master_case_no'
                              name='case_master_case_no'
                              value={
                                partyData.case_master_case_no ||
                                partyData.case_master_case_no
                              }
                              onChange={onChangeHandle}
                              type='text'
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* Aggrement Detail */}
            {registerMasterField?.pty_acc_agr_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(2)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: 'orange' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Aggrement Detail
                  </div>
                  {openAccordion === 2 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 2
                  }
                >
                  <CardBody>
                    <Form>
                      <Row>
                        <Col sm={4}>
                          <FormGroup>
                            <Label for='hire_status'>
                              Aggrement Type
                              <i
                                className='fa fa-plus-circle'
                                onClick={() => {
                                  openHelperModal('aggrement');
                                }}
                                style={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: 'blue',
                                  fontSize: 20,
                                }}
                              ></i>
                            </Label>
                            <Input
                              id='hire_status'
                              name='hire_status'
                              value={partyData.hire_status}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                              innerRef={hireStatusRef}
                            >
                              <option value=''>Select</option>
                              {helperMasterAggrementTypeTable.map((option) => (
                                <option
                                  key={option.id}
                                  value={option.field_data}
                                >
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>

                            {errorMessage.hire_status && (
                              <FormText color='danger'>
                                {errorMessage.hire_status}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                        <Col sm={4}>
                          <FormGroup>
                            <Label for='agreement_start_date'>
                              Agr Start Date
                            </Label>
                            <Input
                              id='agreement_start_date'
                              name='agreement_start_date'
                              value={
                                partyData.agreement_start_date?.split('T')[0]
                              }
                              onChange={onChangeHandle}
                              type='date'
                            />
                            {errorMessage.agreement_start_date && (
                              <FormText color='danger'>
                                {errorMessage.agreement_start_date}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm={4}>
                          <FormGroup>
                            <Label for='agreement_end_date'>Agr End Date</Label>
                            <Input
                              id='agreement_end_date'
                              name='agreement_end_date'
                              value={
                                partyData.agreement_end_date?.split('T')[0]
                              }
                              onChange={onChangeHandle}
                              type='date'
                            />
                            {errorMessage.agreement_end_date && (
                              <FormText color='danger'>
                                {errorMessage.agreement_end_date}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>
                          <FormGroup>
                            <Label for='bill_type'>
                              Bill Type{' '}
                              <i
                                className='fa fa-plus-circle'
                                onClick={() => {
                                  openHelperModal('bill_type');
                                }}
                                style={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: 'blue',
                                  fontSize: 20,
                                }}
                              ></i>
                            </Label>
                            <Input
                              id='bill_type'
                              name='bill_type'
                              value={partyData.bill_type}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              {helperMasterBillTypeTable.map((option) => (
                                <option
                                  key={option.id}
                                  value={option.field_data}
                                >
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                            {errorMessage.bill_type && (
                              <FormText color='danger'>
                                {errorMessage.bill_type}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm={4}>
                          <FormGroup>
                            <Label for='security_amount'>Security Amt</Label>
                            <Input
                              id='security_amount'
                              name='security_amount'
                              value={partyData.security_amount || ''}
                              onChange={onChangeHandle}
                              type='number'
                            />
                            {errorMessage.security_amount && (
                              <FormText color='danger'>
                                {errorMessage.security_amount}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm={4}>
                          <FormGroup>
                            <Label for='dr'>DR/CR (Security Amt)</Label>
                            <Input
                              id='dr'
                              name='dr'
                              value={partyData.dr}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              <option value=''>Select</option>
                              <option value='debit'>Debit</option>
                              <option value='credit'>Credit</option>
                            </Input>
                            {errorMessage.dr && (
                              <FormText color='danger'>
                                {errorMessage.dr}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4}>
                          <FormGroup>
                            <Label for='tax_type'>
                              {' '}
                              Tax Type
                              <i
                                className='fa fa-plus-circle'
                                onClick={() => {
                                  openHelperModal('tax_type');
                                }}
                                style={{
                                  cursor: 'pointer',
                                  marginLeft: '10px',
                                  color: 'blue',
                                  fontSize: 20,
                                }}
                              ></i>
                            </Label>
                            <Input
                              id='tax_type'
                              name='tax_type'
                              value={partyData.tax_type}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                            >
                              {helperMasterTaxTypeTable.map((option) => (
                                <option
                                  key={option.id}
                                  value={option.field_data}
                                >
                                  {option.field_name}
                                </option>
                              ))}
                            </Input>
                            {errorMessage.tax_type && (
                              <FormText color='danger'>
                                {errorMessage.tax_type}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm={4}>
                          <FormGroup>
                            <Label for='percentage'>GST Tax %</Label>
                            <Input
                              id='percentage'
                              name='percentage'
                              value={partyData?.percentage || ''}
                              onChange={onChangeHandle}
                              type='select'
                              className='custom-select'
                              min='0'
                              max='100'
                              maxLength={5}
                              disabled={partyData.tax_type == 'not_applicable'}
                            >
                              {partyData.tax_type == 'not_applicable' ? (
                                <>
                                  <option value='0'>0</option>
                                </>
                              ) : (
                                <>
                                  <option value=''>Select</option>
                                  {helperMasterTaxPercentageTable.map(
                                    (option) => (
                                      <option
                                        key={option.id}
                                        value={option.field_data}
                                      >
                                        {option.field_data}
                                      </option>
                                    ),
                                  )}
                                </>
                              )}
                            </Input>
                            {errorMessage.percentage && (
                              <FormText color='danger'>
                                {errorMessage.percentage}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        {/* <Col>
                            <FormGroup>
                              <Label for="gstin">GSTIN</Label>
                              <Input  
                                id="gstin"
                                name="gstin"
                                value={partyData.gstin}
                                onChange={onChangeHandle}
                                type="text"
                              />
                              {errorMessage.gstin && (
                                <FormText color="danger">{errorMessage.gstin}</FormText>
                              )}
                            </FormGroup>
                          </Col> */}
                        <Col xl={4}>
                          <FormGroup>
                            <Label for='ref_by'>Ref By</Label>
                            <Input
                              id='ref_by'
                              name='ref_by'
                              value={partyData.ref_by}
                              onChange={onChangeHandle}
                              type='text'
                            />
                            {errorMessage.ref_by && (
                              <FormText color='danger'>
                                {errorMessage.ref_by}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={4}>
                          <FormGroup>
                            <Label for='ref_commission'>Ref Commission %</Label>
                            <Input
                              id='ref_commission'
                              name='ref_commission'
                              value={partyData.ref_commission}
                              onChange={onChangeHandle}
                              type='text'
                            />
                            {errorMessage.ref_commission && (
                              <FormText color='danger'>
                                {errorMessage.ref_commission}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* // address detail */}
            {registerMasterField?.pty_acc_addr_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(3)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: 'red' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Address Detail
                  </div>
                  {openAccordion === 3 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>

                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 3
                  }
                >
                  <CardBody>
                    {/* <Button color="primary" onClick={() => { handleAddRow("address") }} style={{ marginBottom: 20 }}>Add Address More</Button> */}
                    {addressTanxList.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          marginBottom: 20,
                          border: '1px solid #dee2e6',
                          padding: 10,
                          borderRadius: 20,
                        }}
                      >
                        <Row>
                          <Col sm='12'>
                            <FormGroup>
                              <Label for='party_address_description'>
                                Address Type:
                                <i
                                  className='fa fa-plus-circle'
                                  onClick={() => {
                                    openHelperModal('party_address_detail');
                                  }}
                                  style={{
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    color: 'blue',
                                    fontSize: 20,
                                  }}
                                ></i>
                              </Label>
                              <Input
                                type='select'
                                className='custom-select'
                                name='party_address_description'
                                id='party_address_description'
                                value={item.party_address_description}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              >
                                <option value=''>Select</option>
                                {helperMasterAddressTable.map((option) => (
                                  <option
                                    key={option.id}
                                    value={option.field_data}
                                  >
                                    {option.field_data}
                                  </option>
                                ))}
                              </Input>
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index][
                                  'party_address_description'
                                ] && (
                                  <span style={{ color: 'red' }}>
                                    {
                                      errorArrayMessage[index][
                                        'party_address_description'
                                      ]
                                    }
                                  </span>
                                )}
                            </FormGroup>
                          </Col>

                          <Col sm='12'>
                            <FormGroup>
                              <Label for='party_address_1'>
                                Address Line 1{' '}
                              </Label>
                              {/* <Label for="party_address_1" style={{ marginLeft: 20, backgroundColor: "skyblue", color: "black", padding: 5, borderRadius: 10 }} onClick={(e) => { refreshAddress(e, index) }}>  Refresh Address  </Label> */}

                              <Button
                                color='primary'
                                size='sm'
                                style={{
                                  marginLeft: 20,
                                  borderRadius: 10,
                                }}
                                onClick={(e) => {
                                  refreshAddress(e, index);
                                }}
                              >
                                Refresh Address
                              </Button>
                              <Input
                                type='text'
                                name='party_address_1'
                                id='party_address_1'
                                value={item.party_address_1}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_address_1'] && (
                                  <span style={{ color: 'red' }}>
                                    {
                                      errorArrayMessage[index][
                                        'party_address_1'
                                      ]
                                    }
                                  </span>
                                )}
                            </FormGroup>
                          </Col>

                          <Col sm='12'>
                            <FormGroup>
                              <Label for='party_address_2'>
                                Address Line 2:
                              </Label>
                              <Input
                                type='text'
                                name='party_address_2'
                                id='party_address_2'
                                value={item.party_address_2}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              />
                            </FormGroup>
                          </Col>

                          <Col sm='12'>
                            <FormGroup>
                              <Label for='party_address_location'>
                                Location/Lankmarks:
                              </Label>
                              <Input
                                type='text'
                                name='party_address_location'
                                id='party_address_location'
                                value={item.party_address_location}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index][
                                  'party_address_location'
                                ] && (
                                  <span style={{ color: 'red' }}>
                                    {
                                      errorArrayMessage[index][
                                        'party_address_location'
                                      ]
                                    }
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_state'>State:</Label>
                              <Input
                                type='select'
                                className='custom-select'
                                name='party_state'
                                id='party_state'
                                value={item.party_state}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              >
                                <option value=''>Select</option>
                                {stateTable.map((option) => (
                                  <option
                                    key={option.state_Id}
                                    value={option.state_Name}
                                  >
                                    {option.state_Name}
                                  </option>
                                ))}
                              </Input>
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_state'] && (
                                  <span style={{ color: 'red' }}>
                                    {errorArrayMessage[index]['party_state']}
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_city'>
                                City:{' '}
                                <i
                                  className='fa fa-plus-circle'
                                  onClick={() => {
                                    openStateCityModal(item.party_state);
                                  }}
                                  style={{
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    color: 'blue',
                                    fontSize: 20,
                                  }}
                                ></i>
                              </Label>
                              {/* <Input
                                  
                                  type="select"  className="custom-select"
                                  name="party_city"
                                  id="party_city"
                                  value={item.party_city}
                                  onChange={(e) => onHandleAddressTranxChange(e, index)}
                                >
                                  <option>Select City</option>

                                  {
                                    (() => {
                                      // Find selected state once

                                      return cityTable
                                        .filter(city => city.state_Name === item.party_state)
                                        .map(data => (
                                          <option key={data.id} value={data.city_Name}>
                                            {data.city_Name}
                                          </option>
                                        ));
                                    })()
                                  }
                                </Input> */}

                              <Autocomplete
                                size='small'
                                autoHighlight
                                id={`city_${index}`} // unique ID if inside a loop
                                name='party_city'
                                options={
                                  cityTable.filter(
                                    (city) =>
                                      city.state_id === item.party_state_id,
                                  ) || []
                                }
                                getOptionLabel={(option) =>
                                  option.city_name || ''
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder='Select City'
                                  />
                                )}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.id}>
                                    {option.city_name}
                                  </li>
                                )}
                                value={
                                  cityTable.find(
                                    (option) =>
                                      option.city_name == item.party_city,
                                  ) || null
                                }
                                onChange={(event, value) => {
                                  onHandleAddressTranxChange(
                                    {
                                      target: {
                                        name: 'party_city',
                                        value: value?.city_name || '',
                                      },
                                    },
                                    index,
                                  );
                                }}
                              />

                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_city'] && (
                                  <span style={{ color: 'red' }}>
                                    {errorArrayMessage[index]['party_city']}
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_pincode'>Pincode:</Label>
                              <Input
                                type='number'
                                name='party_pincode'
                                id='party_pincode'
                                value={item.party_pincode}
                                min='0'
                                onChange={(e) => {
                                  let val = e.target.value;
                                  if (/^\d*$/.test(val) && val.length <= 6) {
                                    onHandleAddressTranxChange(e, index);
                                  }
                                }}
                                // onChange={(e) => onHandleAddressTranxChange(e, index)}
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_pincode'] && (
                                  <span style={{ color: 'red' }}>
                                    {errorArrayMessage[index]['party_pincode']}
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_gst_type'>GST Type:</Label>
                              <Input
                                type='text'
                                name='party_gst_type'
                                id='party_gst_type'
                                value={item.party_gst_type}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                                disabled
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_gst_type'] && (
                                  <span style={{ color: 'red' }}>
                                    {errorArrayMessage[index]['party_gst_type']}
                                  </span>
                                )}
                            </FormGroup>
                          </Col>

                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_gst_code'>State Code:</Label>
                              <Input
                                type='number'
                                name='party_gst_code'
                                id='party_gst_code'
                                value={item.party_gst_code}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index]['party_gst_code'] && (
                                  <span style={{ color: 'red' }}>
                                    {errorArrayMessage[index]['party_gst_code']}
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                          <Col sm={4}>
                            <FormGroup>
                              <Label for='party_gst_address_no'>
                                GST Number:
                              </Label>
                              <Input
                                type='text'
                                name='party_gst_address_no'
                                id='party_gst_address_no'
                                value={item.party_gst_address_no}
                                onChange={(e) =>
                                  onHandleAddressTranxChange(e, index)
                                }
                              />
                              {errorArrayMessage[index] &&
                                errorArrayMessage[index][
                                  'party_gst_address_no'
                                ] && (
                                  <span style={{ color: 'red' }}>
                                    {
                                      errorArrayMessage[index][
                                        'party_gst_address_no'
                                      ]
                                    }
                                  </span>
                                )}
                            </FormGroup>
                          </Col>
                        </Row>

                        {item.party_address_description != 'primary' && (
                          <Button
                            type='button'
                            color='danger'
                            onClick={() => {
                              handleAddressRemoveRow(index);
                            }}
                          >
                            Remove
                          </Button>
                        )}
                      </div>
                    ))}

                    <Button
                      color='primary'
                      onClick={() => {
                        handleAddRow('address');
                      }}
                      style={{ marginBottom: 20 }}
                    >
                      Add Address
                    </Button>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* //Contact Detail  */}

            {registerMasterField?.pty_acc_cont_yn == 'yes' && (
              <div>
                <CardTitle
                  tag='h6'
                  className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between'
                  style={{
                    borderBottom:
                      'var(--bs-border-width) var(--bs-border-style) #000000',
                  }}
                  onClick={() => toggleAccordion(4)}
                >
                  <div
                    className='d-flex align-items-center'
                    style={{ fontWeight: 'bold', color: 'blue' }}
                  >
                    <i className='bi bi-bell mr-2'></i>
                    Contact Detail
                  </div>

                  {openAccordion === 4 ? (
                    <i className='bi bi-caret-up'></i>
                  ) : (
                    <i className='bi bi-caret-down'></i>
                  )}
                </CardTitle>
                <Collapse
                  isOpen={
                    Object.keys(errorMessage).length != 0
                      ? true
                      : openAccordion === 4
                  }
                >
                  <CardBody>
                    <Form>
                      {/* <Button color="primary" onClick={() => { handleAddRow("contact") }} style={{ marginBottom: 20 }}>Add Contact More</Button> */}
                      {contactTanxList.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: 20,
                            border: '1px solid #dee2e6',
                            padding: 10,
                            borderRadius: 20,
                          }}
                        >
                          <Row>
                            <Col sm={12}>
                              <FormGroup>
                                <Label for={`party_contact_description`}>
                                  Contact Type:
                                </Label>
                                <Input
                                  type='select'
                                  className='custom-select'
                                  name={`party_contact_description`}
                                  id={`party_contact_description`}
                                  value={item.party_contact_description}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                >
                                  <option value=''>Select</option>
                                  {helperMasterContactTable.map((option) => (
                                    <option
                                      key={option.id}
                                      value={option.field_data}
                                    >
                                      {option.field_data}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_name`}>Name:</Label>
                                <Input
                                  type='text'
                                  name={`party_contact_name`}
                                  id={`party_contact_name`}
                                  value={item.party_contact_name}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_department`}>
                                  Department:
                                  <i
                                    className='fa fa-plus-circle'
                                    onClick={() => {
                                      openHelperModal('department');
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      marginLeft: '10px',
                                      color: 'blue',
                                      fontSize: 20,
                                    }}
                                  ></i>
                                </Label>
                                <Input
                                  type='select'
                                  className='custom-select'
                                  name={`party_contact_department`}
                                  id={`party_contact_department`}
                                  value={item.party_contact_department}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                >
                                  <option value=''>Select</option>
                                  {helperMasterDepartmentTable.map((option) => (
                                    <option
                                      key={option.id}
                                      value={option.field_data}
                                    >
                                      {option.field_name}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_designation`}>
                                  Designation:
                                  <i
                                    className='fa fa-plus-circle'
                                    onClick={() => {
                                      openHelperModal('designation');
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      marginLeft: '10px',
                                      color: 'blue',
                                      fontSize: 20,
                                    }}
                                  ></i>
                                </Label>
                                <Input
                                  type='select'
                                  className='custom-select'
                                  name={`party_contact_designation`}
                                  id={`party_contact_designation`}
                                  value={item.party_contact_designation}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                >
                                  <option value=''>Select</option>
                                  {helperMasterDesignationTable.map(
                                    (option) => (
                                      <option
                                        key={option.id}
                                        value={option.field_data}
                                      >
                                        {option.field_name}
                                      </option>
                                    ),
                                  )}
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_landline_no`}>
                                  Landline No.:
                                </Label>
                                <Input
                                  type='number'
                                  name={`party_landline_no`}
                                  id={`party_landline_no`}
                                  value={item.party_landline_no}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_mobile`}>
                                  Mobile No.:
                                </Label>
                                <Input
                                  type='number'
                                  name={`party_contact_mobile`}
                                  id={`party_contact_mobile`}
                                  value={item.party_contact_mobile}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_whatsapp_mobile`}>
                                  Whatsapp Mobile No.:
                                </Label>
                                <Input
                                  type='number'
                                  name={`party_contact_whatsapp_mobile`}
                                  id={`party_contact_whatsapp_mobile`}
                                  value={item.party_contact_whatsapp_mobile}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_email`}>
                                  Email:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_email`}
                                  id={`party_contact_email`}
                                  value={item.party_contact_email}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_website`}>
                                  Website:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_website`}
                                  id={`party_contact_website`}
                                  value={item.party_contact_website}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_twitter_id`}>
                                  Twitter Id:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_twitter_id`}
                                  id={`party_contact_twitter_id`}
                                  value={item.party_contact_twitter_id}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_fb_id`}>
                                  Facebook Id:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_fb_id`}
                                  id={`party_contact_fb_id`}
                                  value={item.party_contact_fb_id}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_instagram_id`}>
                                  Instagram Id:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_instagram_id`}
                                  id={`party_contact_instagram_id`}
                                  value={item.party_contact_instagram_id}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_youtube_id`}>
                                  YouTube channel Id:
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_youtube_id`}
                                  id={`party_contact_youtube_id`}
                                  value={item.party_contact_youtube_id}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_isd_code`}>
                                  {' '}
                                  ISD Code
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_isd_code`}
                                  id={`party_contact_isd_code`}
                                  value={item.party_contact_isd_code}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_std_code`}>
                                  STD Code
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_std_code`}
                                  id={`party_contact_std_code`}
                                  value={item.party_contact_std_code}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for={`party_contact_fax_code`}>
                                  Fax Code
                                </Label>
                                <Input
                                  type='text'
                                  name={`party_contact_fax_code`}
                                  id={`party_contact_fax_code`}
                                  value={item.party_contact_fax_code}
                                  onChange={(e) =>
                                    onHandleContactTranxChange(e, index)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Button
                            type='button'
                            color='danger'
                            onClick={() => handleContactRemoveRow(index)}
                          >
                            Remove
                          </Button>
                        </div>
                      ))}
                    </Form>
                    <Button
                      color='primary'
                      onClick={() => {
                        handleAddRow('contact');
                      }}
                      style={{ marginBottom: 20 }}
                    >
                      Add Contact
                    </Button>
                  </CardBody>
                </Collapse>
              </div>
            )}

            {/* Remark Detail and Upload detail  */}
            {registerMasterField?.pty_acc_cont_yn == 'yes' && (
              <div>
                <RemarkPage
                  fromName={'remark_detail_document_party'}
                  openHelperModal={openHelperModal}
                  remarkPageArrayList={remarkPageArrayList}
                  setremarkPageArrayList={setremarkPageArrayList}
                  deleteRemarkPageArrayList={deleteRemarkPageArrayList}
                  setDeleteRemarkPageArrayList={setDeleteRemarkPageArrayList}
                  helperMasterDocumentTypeTable={helperMasterDocumentTypeTable}
                />
              </div>
            )}

            {/* Error Show */}
            <CardBody>
              {Object.keys(errorMessage).length !== 0 &&
                Object.values(errorMessage).some((value) => !!value) && (
                  <div
                    style={{
                      padding: 10,
                      border: '2px solid #ddd',
                      borderRadius: 20,
                      textAlign: 'left',
                    }}
                  >
                    {Object.keys(errorMessage).map((key, index) => (
                      <p key={key} style={{ color: 'red' }}>
                        {errorMessage[key]}
                      </p>
                    ))}
                  </div>
                )}

              {errorArrayMessage.length !== 0 && (
                <div
                  style={{
                    padding: 10,
                    border: '2px solid #ddd',
                    borderRadius: 20,
                    textAlign: 'left',
                  }}
                >
                  {errorArrayMessage.map((errorObject, index) => (
                    <div key={index}>
                      {Object.keys(errorObject).map((key, index) => (
                        <p key={key} style={{ color: 'red' }}>
                          {index + 1}: {errorObject[key]}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </CardBody>

            {/* Error Model */}
            <ErrorModal
              show={showErrorModal}
              title='Validation / Action Required'
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
              // onConfirm={true}
            />

            {/* Model */}
            {/* //================================================================= */}
            <CustomerAddHelperMaster
              show={showHelperModal}
              fromName={fromName}
              closedModel={closedHelperModal}
              fetchHelperData={fetchHelperData}
              vendormasterId={partyData.party_branch_vendor_id}
              branchMasterId={partyData.party_branch_master_id}
              helperMasterWorkBussinessTable={helperMasterWorkBussinessTable}
            />

            {/* State and City Model   */}
            <CustomModal
              show={showSateCityModel}
              title={'Add State City Model'}
              // onCancel={closeSingleItemModel}
              // onConfirm={confirmSingleItemExtraDetailModel}
              content={
                <>
                  <AddCityMaster
                    onInsert={onInsertSingleItemModel}
                    onCancel={closedStateCityModal}
                  />
                </>
              }
            ></CustomModal>
          </Card>
        </>
      ) : model == 'item' ? (
        <ItemRateMaster
          partyId={partyData.id}
          partyName={partyData.name}
          backButton={backTOPartyMaster}
        />
      ) : model == 'aggrement' ? (
        <Aggrement
          partyId={partyData.id}
          partyName={partyData.name}
          backButton={backTOPartyMaster}
        />
      ) : null}
    </>
  );
};

export default AddParty;
